<ngx-spinner bdColor="rgba(51,51,51,0.9)" size="medium" color="rgb(32,39,59)" type="square-spin"></ngx-spinner>
<mat-progress-bar [style.display]="isFullyLoaded ? 'none' : 'block'" mode="indeterminate"></mat-progress-bar>

<div class="px-4 py-3" id="c-f">
  <p class="text-sm text-gr900 capitalize">
    Welcome, {{ lastname | lowercase }} {{ firstname | lowercase }}
  </p>

  <!-- top cards -->
  <div class="grid-cols-auto [--col-w:10rem] gap-6 sm:grid-cols-2 lg:grid-cols-4 pt-3">
    <div class="shadow-sm rounded bg-white p-3 gap-3 flex items-center relative overflow-hidden"
      *ngFor="let item of getCards()">
      <mat-icon name="user" [style.color]="item.color"
        class="absolute text-[8rem] -top-16 opacity-30 right-10">{{ item.icon }}</mat-icon>
      <mat-icon name="user" [style.color]="item.color">{{
        item.icon
      }}</mat-icon>
      <div class="flex flex-col border-l pl-3 relative">
        <h3 class="text-xl font-semibold uppercase">{{ item.value }}</h3>
        <p class="text-xs text-ndgray">{{ item.label }}</p>
      </div>
    </div>
  </div>

  <div class="grid mt-6 grid-cols-12 gap-6">
    <!-- invoices -->
    <div class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 xl:col-span-3 p-3 flex flex-col rounded">
      <div class="flex justify-between pb-3 border-b items-center gap-2 flex-wrap">
        <h3 class="font-medium">Invoice(s)</h3>
        <a routerLink="/home/payment-history" class="bg-[#2196F3]/10 px-2 py-1 rounded-md text-xs">View All</a>
      </div>
      <div class="flex h-full flex-col gap-3">
        <div class="h-full text-ndgray text-sm flex items-center justify-center text-center p-3"
          *ngIf="paymentHistory.length == 0">
          You currently do not have any invoice
        </div>
        <div *ngFor="let ph of paymentHistory" class="flex justify-between bg-slate-50 rounded p-3 items-center gap-4">
          <div class="flex flex-col w-full">
            <span class="leading-5 text-sm font-medium uppercase">{{
              ph.label
            }}</span>
            <div class="w-full text-ndgray text-xs flex flex-wrap gap-2 justify-between">
              <span class="">{{
                ph.total_amount | currency : "NGN" : "symbol-narrow"
              }}</span>
              <span class="gap-2 flex items-center">
                <span>
                  Paid:
                  <span class="text-green-600">{{
                    ph.total_paid | currency : "NGN" : "symbol-narrow"
                  }}</span></span>
                <span>
                  Bal:
                  <span class="text-rd1000">{{
                    ph.amount_remaining | currency : "NGN" : "symbol-narrow"
                  }}</span></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- opened test  (psec) -->
    <div *ngIf="system != 'tert'"
      class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 xl:col-span-4 2xl:col-span-3 p-3 flex flex-col rounded">
      <h3 class="font-medium pb-3 border-b">Opened Tests</h3>
      <div class="flex h-full flex-col gap-3">
        <div
          class="h-full text-ndgray text-sm max-w-60 mx-auto flex flex-col items-center justify-center text-center p-3"
          *ngIf="examCategories.length == 0">
          <i class="bx bx-question-mark text-3xl text-gr500"></i>
          You currently do not have any opened test
        </div>
        <div *ngFor="let ec of examCategories" class="flex justify-between bg-slate-50 rounded p-3 items-center gap-4">
          <div class="flex flex-col">
            <span class="leading-5 block text-sm">{{
              ec.exam_title
            }}</span>
            <span class="text-xs text-ndgray">{{
              ec.exam_mode == 0 ? "Onsite (Physical)" : "Online (Virtual)"
            }}</span>
          </div>
          <button (click)="startExam(ec)" class="bg-white rounded shadow-sm px-3 text-sm py-2">
            Start
          </button>
        </div>
      </div>
    </div>

    <div
      class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 xl:col-span-5 2xl:col-span-6 p-3 flex flex-col rounded"
      *ngIf="system != 'tert'">
      <div class="flex justify-between pb-3 border-b items-center gap-2 flex-wrap">
        <h3 class="font-medium">{{ resultLabel }}</h3>
        <span class="text-ndgray text-xs">Top {{ system == "tert" ? "Courses" : "Subjects" }}</span>
      </div>
      <div class="flex h-full flex-col gap-3">
        <div class="h-full text-ndgray text-sm flex items-center justify-center text-center p-3"
          *ngIf="topTermSubjects?.length == 0">


          You currently do not have any approved result
        </div>
        <div class="rounded-md border">
          <div *ngFor="let s of topTermSubjects?.slice(0, 7); let i = index"
            class="grid grid-cols-5 border-b text-xs rounded p-2 items-center gap-4">
            <span class="leading-5 col-span-2 text-sm">{{ s?.name }}</span>
            <div class="flex items-center gap-2 col-span-3">
              <div class="overflow-hidden w-full bg-gr100 rounded-full h-2">
                <div [style.background]="chartColors[i]" class="h-full" [style.width]="s?.value + '%'"></div>
              </div>
              <span class="text-xs w-7">{{ s?.value }}%</span>
            </div>
            <!-- <span class="text-xs text-ndgray">{{ s.value }}</span> -->
          </div>
        </div>
      </div>
    </div>

    <div class="col-span-full lg:col-span-6 xl:col-span-3 flex flex-col gap-6" *ngIf="system == 'tert'">
      <div class="shadow-sm flex flex-col text-center items-center justify-center rounded bg-white p-3">
        <p class="text-sm">Course Registration Closes in</p>
        <h3 class="text-2xl font-semibold">{{ displayTime }}</h3>
        <span class="text-xs text-rd1000">{{ resp }}</span>
        <div class="border-t items-center flex pt-3 mt-2 justify-between w-full">
          <div class="flex flex-col">
            <span class="text-sm font-medium">Status</span>
            <!-- <span class="text-xs" *ngIf="!resp">You can update your course selection</span> -->
          </div>
          <i class="{{
              regStatus
                ? 'bx bx-check text-3xl text-green-700'
                : 'bx bx-x text-3xl text-rd1000'
            }}"></i>
          <a routerLink="/home/course-registration" class="hover:no-underline">
            <span
              class="status-td {{ regStatus ? 'success-tag' : 'failed-tag' }}">{{ regStatus ? "View Courses" : "Register Course" }}
            </span>
          </a>
        </div>
      </div>

      <div class="shadow-sm gap-4 bg-white p-3 flex flex-col rounded">
        <div class="flex justify-between pb-3 border-b items-center gap-2 flex-wrap">
          <h3 class="font-medium">{{ resultLabel }}</h3>
          <span class="text-ndgray text-xs">Top {{ system == "tert" ? "Courses" : "Subjects" }}</span>
        </div>
        <div class="flex h-full flex-col gap-3">
          <div class="h-full text-ndgray text-sm flex flex-col items-center justify-center text-center p-3"
            *ngIf="topTermSubjects?.length == 0">
            <i class="bx bx-spreadsheet text-3xl text-gr500 animate-bounce"></i>
            You currently do not have any approved result

          </div>
          <div class="rounded-md border">
            <div *ngFor="let s of topTermSubjects?.slice(0, 5); let i = index"
              class="grid grid-cols-5 border-b text-xs rounded p-2 items-center gap-4">
              <span class="leading-5 col-span-2 text-sm">{{ s?.name }}</span>
              <div class="flex items-center gap-2 col-span-3">
                <div class="overflow-hidden w-full bg-gr100 rounded-full h-2">
                  <div [style.background]="chartColors[i]" class="h-full" [style.width]="s?.value + '%'"></div>
                </div>
                <span class="text-xs w-7">{{ s?.value }}%</span>
              </div>
              <!-- <span class="text-xs text-ndgray">{{ s.value }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- cgpa progress -->
    <div *ngIf="system == 'tert'"
      class="shadow-sm gap-4 bg-white col-span-full xl:col-span-6 p-3 flex flex-col rounded h-full">
      <h3 class="font-medium">Performance</h3>
      <hr>
      <div *ngIf="semester_result.length===0" class="h-full flex flex-col justify-center items-center text-sm">
        <i class="bx bx-spreadsheet text-3xl text-gr500 animate-bounce"></i>
        <h1>You currently do not have any approved result</h1>
      </div>
      <div *ngIf="semester_result.length>0" id="chartContainer" class="min-h-[18rem] h-[calc(100%_-_2rem)]">
        <canvas id="lineChart"></canvas>
      </div>
    </div>

    <!-- <canvas id="doughnutChart"></canvas> -->

    <!-- quick links -->
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 col-span-full h-fit">
      <a *ngFor="let item of quickLinks"
        class="bg-white rounded shadow-sm p-3 flex hover:[text-decoration:none] hover:-translate-y-1 transition-all duration-300 items-center gap-3"
        [routerLink]="item.link">
        <span [style.background]="item.color"
          class="h-8 rounded bg-blue-500 text-white w-8 min-w-8 flex items-center justify-center">
          <i class="{{ item.icon }}"></i>
        </span>
        <div class="flex flex-col">
          <span class="font-medium text-xs">{{ item.label }}</span>
          <p *ngIf="item.link == '/home/pay-tuition'" class="text-xs {{
              balance <= 0 ? 'text-green-700' : 'text-rd1000'
            }}">
            {{ balance | currency : "NGN" : "symbol-narrow" }}
          </p>
        </div>
      </a>
    </div>

    <!-- logs -->
    <div class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 2xl:col-span-3 p-3 flex flex-col rounded">
      <div class="flex justify-between pb-3 border-b items-center gap-2 flex-wrap">
        <h3 class="font-medium">Recent Activities</h3>
      </div>
      <div class="flex h-full flex-col gap-3">
        <div class="h-full text-ndgray text-sm flex items-center justify-center text-center p-3"
          *ngIf="recentLogs.length == 0">
          No Recent Activities found
        </div>
        <div *ngFor="let n of recentLogs"
          class="flex justify-between bg-slate-50 rounded px-3 py-2.5 items-center gap-4">
          <div class="flex flex-col">
            <span class="leading-5 text-sm line-clamp-1">{{ n.details }}</span>
            <span class="text-xs text-ndgray">{{ n.component }}</span>
          </div>
          <div class="flex flex-col text-right text-xs text-ndgray -space-y-1">
            <span class="">{{ n.ago }}</span>
            <!-- <span class="">{{n.created_at | date :'MMM d, y'}}</span>
                        <span class="">{{n.created_at | date :'h:mm a'}}</span> -->
          </div>
        </div>
      </div>
    </div>

    <!-- opened tests (tert) -->
    <div *ngIf="system == 'tert'"
      class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 2xl:col-span-3 p-3 flex flex-col rounded">
      <h3 class="font-medium pb-3 border-b">Opened Tests</h3>
      <div class="flex h-full flex-col gap-3">
        <div
          class="h-full text-ndgray text-sm max-w-60 mx-auto flex flex-col items-center justify-center text-center p-3"
          *ngIf="examCategories.length == 0">
          <i class="bx bx-question-mark text-3xl text-gr500 animate-bounce"></i>
          You currently do not have any opened test
        </div>
        <div *ngFor="let ec of examCategories" class="flex justify-between bg-slate-50 rounded p-3 items-center gap-4">
          <div class="flex flex-col">
            <span class="leading-5 text-sm">{{ ec.exam_title }}</span>
            <span class="text-xs text-ndgray">{{
              ec.exam_mode == 0 ? "Onsite (Physical)" : "Online (Virtual)"
            }}</span>
          </div>
          <button (click)="startExam(ec)" class="bg-white rounded shadow-sm px-3 text-sm py-2">
            Start
          </button>
        </div>
      </div>
    </div>

    <!-- virtual classes -->
    <div class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 {{
        system == 'tert' ? '2xl:col-span-3' : ''
      }} p-3 flex flex-col rounded">
      <h3 class="font-medium pb-3 border-b">Virtual Classes</h3>
      <div class="flex h-full flex-col gap-3">
        <div
          class="h-full text-ndgray text-sm max-w-60 mx-auto flex flex-col items-center justify-center text-center p-3"
          *ngIf="virtualClasses.length == 0">
          <i class="bx bx-notepad text-3xl text-gr500 animate-bounce"></i>
          There's no opened Virtual Class at the moment
        </div>
        <div *ngFor="let vc of virtualClasses" class="flex justify-between bg-slate-50 rounded p-3 items-center gap-4">
          <div class="flex flex-col">
            <span class="leading-5 text-sm">{{ vc.name }}</span>
            <span class="text-xs text-ndgray">{{ vc.title }}</span>
          </div>
          <button (click)="joinVirtualClass(vc.code, vc.title)" class="bg-white rounded shadow-sm px-3 text-sm py-2">
            Join
          </button>
        </div>
      </div>
    </div>

    <!-- notice board -->
    <div class="shadow-sm gap-4 bg-white col-span-full lg:col-span-6 2xl:col-span-3 p-3 flex flex-col rounded">
      <div class="flex justify-between pb-3 border-b items-center gap-2 flex-wrap">
        <h3 class="font-medium">Notice Board</h3>
        <a routerLink="/home/notice-board" class="bg-[#2196F3]/10 px-2 py-1 rounded-md text-xs">View All</a>
      </div>
      <div class="flex h-full flex-col gap-3">
        <div
          class="h-full text-ndgray text-sm max-w-60 mx-auto flex flex-col items-center justify-center text-center p-3"
          *ngIf="allNoticeArray.length == 0">
          <i class="bx bx-chalkboard text-3xl text-gr500 animate-bounce"></i>
          Notice Board is currently Empty
        </div>
        <div *ngFor="let n of allNoticeArray" class="flex justify-between bg-slate-50 rounded p-3 items-center gap-4">
          <div class="flex flex-col">
            <span class="leading-5 text-sm line-clamp-1">{{
              n.notice_title
            }}</span>
            <!-- <span class="text-xs text-ndgray line-clamp-2" [innerHTML]="n.notice_content"></span> -->
            <span class="text-xs text-ndgray {{
                n.notice_urgency == 2
                  ? 'text-red-600'
                  : n.notice_urgency == 1
                  ? 'text-green-600'
                  : 'text-orange-600'
              }}">{{ urgency[n.notice_urgency] }}</span>
          </div>
          <div class="flex flex-col text-right text-xs text-ndgray -space-y-1">
            <span class="">{{ n.created_at | date : "MMM d, y" }}</span>
            <span class="">{{ n.created_at | date : "h:mm a" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>